import React, { useState, useEffect } from 'react';
import ReportModal from './ReportModal';

/**
 * Global Report Modal wrapper that listens for custom events to open the report modal.
 * Mount this once in AuthenticatedLayout or App.
 * 
 * Usage: Dispatch a custom event to open the modal:
 * window.dispatchEvent(new CustomEvent('virtulingu:openReportModal', {
 *   detail: { userId: '...', displayName: '...', context: 'messenger' }
 * }));
 */
const GlobalReportModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [reportTarget, setReportTarget] = useState({
    userId: null,
    displayName: null,
    context: 'general',
  });

  useEffect(() => {
    const handleOpenReport = (event) => {
      const { userId, displayName, context } = event.detail || {};
      if (userId) {
        setReportTarget({ userId, displayName, context: context || 'general' });
        setIsOpen(true);
      }
    };

    window.addEventListener('virtulingu:openReportModal', handleOpenReport);
    return () => window.removeEventListener('virtulingu:openReportModal', handleOpenReport);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setReportTarget({ userId: null, displayName: null, context: 'general' });
  };

  return (
    <ReportModal
      isOpen={isOpen}
      onClose={handleClose}
      reportedUserId={reportTarget.userId}
      reportedUserName={reportTarget.displayName}
      context={reportTarget.context}
    />
  );
};

export default GlobalReportModal;
